import {
  faEllipsisH,
  faEllipsisV,
  faPlus,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  ListItem,
  ListItemIcon,
  ListItemText,
  MenuItem,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { Menu } from "../../external/common/Menu";
import { TextToggledit } from "../../external/common/TextToggledit";

import "./Lookbooks.scss";
import EightSmall from "./EightSmall";
import OneBigFourSmall from "./OneBigFourSmall";
import TwoBig from "./TwoBig";
import { BrandProfile } from "../../domain/BrandProfile";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";

const Lookbooks: React.FC<{
  template: number;
  onSetTemplate: (template: number) => void;
  images: any[];
  index: number;
  chunkSize: number;
  loadingPreview: boolean | number;
}> = (props) => {
  const { chunkSize, index } = props;

  const slidePadrao = {
    remover: false,
    imageSrc: "",
    id: null,
  };
  const { values, setFieldValue } = useFormikContext<BrandProfile>();
  const { t } = useTranslation();

  const handleNewSlide = () => {
    let images: any = props.images.filter((item) => item.imageSrc !== "");

    const templateSoma = [8, 5, 2];

    if (images.length === templateSoma[values.history.lookbooks.template - 1]) {
      setFieldValue(
        `history.lookbooks.images[${values.history.lookbooks.images.length}]`,
        slidePadrao
      );
    }

    setTimeout(() => {
      var bullets = document.querySelectorAll(".swiper-pagination-bullet");
      const bullet = bullets[bullets.length - 1] as any;
      bullet.click();
    }, 500);
  };

  const handleRemoverSlide = () => {
    setFieldValue(`history.lookbooks.images`, [
      ...values.history.lookbooks.images.slice(
        0,
        values.history.lookbooks.images.length - 1
      ),
    ]);
  };

  return (
    <div className="lookbooks">
      <div className="images">
        {props.template === 1 && (
          <EightSmall
            loadingPreview={props.loadingPreview}
            images={props.images}
          />
        )}
        {props.template === 2 && (
          <OneBigFourSmall
            loadingPreview={props.loadingPreview}
            images={props.images}
          />
        )}
        {props.template === 3 && (
          <TwoBig loadingPreview={props.loadingPreview} images={props.images} />
        )}
        <div className="actions">
          <div className="container-icons">
            <FontAwesomeIcon
              onClick={handleNewSlide}
              title={t("New Slide", "New Slide")}
              icon={faPlus}
            />
            {JSON.stringify(
              values.history.lookbooks.images[
                values.history.lookbooks.images.length - 1
              ]
            ) === JSON.stringify(slidePadrao) && chunkSize - 1 === index ? (
              <FontAwesomeIcon
                onClick={handleRemoverSlide}
                title={t("Remove", "Remove")}
                icon={faTrash}
              />
            ) : null}
          </div>
          <Menu
            icon={faEllipsisV}
            render={({ close, t }) => {
              return (
                <MenuItem>
                  <ListItem>
                    {t("Template", "Template")}:{" "}
                    <select
                      value={props.template}
                      onChange={(e) =>
                        props.onSetTemplate(parseInt(e.target.value))
                      }
                    >
                      <option value={1}>{t("8 small", "8 small")}</option>
                      <option value={2}>
                        {t("1 big and 4 small", "1 big and 4 small")}
                      </option>
                      <option value={3}>{t("Two big", "Two big")}</option>
                    </select>
                  </ListItem>
                </MenuItem>
              );
            }}
          ></Menu>
        </div>
      </div>
    </div>
  );
};

export default Lookbooks;
